import { render, staticRenderFns } from "./SHeader.vue?vue&type=template&id=6fce6d3e&scoped=true&"
import script from "./SHeader.vue?vue&type=script&lang=js&"
export * from "./SHeader.vue?vue&type=script&lang=js&"
import style0 from "./SHeader.vue?vue&type=style&index=0&id=6fce6d3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fce6d3e",
  null
  
)

export default component.exports